import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* loadPublicConfiguration3() {
  var payload = {
    action: "portal/loadPublicConfiguration3",
  };
  yield put(serverRequest(payload));
}

export default loadPublicConfiguration3;
